import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiEdit, FiMenu } from "react-icons/fi";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import ProfileSidebarMenu from "../components/profile/ProfileSidebarMenu"; // Import the Sidebar component
import { IMAGE_URL, REACT_APP_API_PORT } from "../Api";
import axios from "axios";
import Loader from "../components/Loader";
import { getDecryptedData } from "../config/crypto";
import MyCourses from "../components/profile/MyCourses";
import CoursePayments from "../components/profile/CoursePayments";
import CourseCertificate from "../components/profile/CourseCertificate";
import MyTools from "../components/profile/MyTools";
import MyPrompts from "../components/profile/MyPrompts";
import moment from "moment";
const MyProfile = () => {
  const navigate = useNavigate()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Purchased Plans");
  const [apiIsLoading, setapiIsLoading] = useState(false)
  const [data, setData] = useState([])
  const [categories, setCategories] = useState([]);
  const [latestCompleted, setlatestCompleted] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };



  // Content for each tab
  const tabContent = {

    "My Courses": <MyCourses />,
    "Course Payments": <CoursePayments />,
    "Course Certificates": <CourseCertificate />,
    "My Tools": <MyTools />,
    "Purchased Plans": <MySubscription data={data} />,
    "Saved Prompts": <MyPrompts />,
    "Purchased": (
      <MyBundles
        categories={categories}
        isLoading={isLoading}
        visibleCount={visibleCount}
      />
    ),
  };

  const getData = async () => {
    try {
      setapiIsLoading(true);
      const token = getDecryptedData('token')
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/auth/getprofile`, {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        }
      }
      );
      setapiIsLoading(false);
      if (res.data.status) {
        setData(res.data.data);
        const completedNew = res.data.data?.memberships?.filter(m => (m.status === "completed" || m.status === "Completed"))
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))?.[0];
        setlatestCompleted(completedNew)
      }

    } catch (err) {
      setapiIsLoading(false);
      console.log(err);
    }
  };

  const fetchPurchasedCategories = async () => {
    console.log("🔥 fetchPurchasedCategories CALLED");
      try {
        setIsLoading(true);

        const token = getDecryptedData('token')


        const res = await axios.get(
          `${REACT_APP_API_PORT}user/prompts_bundle/user/prompt-bundle/categories`,
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': token
            }
          }
        );

        if (res.data.status) {
          setCategories(res.data.categories || []);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

 

  useEffect(()=>{
      Promise.all([getData(), fetchPurchasedCategories()])
    },[])



  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  console.log("latest", latestCompleted)
  console.log("data", data)

  return (
    <>
      <Loader isLoading={apiIsLoading} />
      {/* <TopBar /> */}
      <Header />

      <div className="MyProfile bg-background-back1 p-3 pt-32">
        {/* Profile Banner */}
        <div className="container mx-auto px-4 max-w-[80rem] pt-10 ">
        
        </div>

        <div className="container mx-auto px-4 max-w-[80rem]">
  <div className="flex flex-col md:flex-row md:items-start gap-6">
    
    {/* Avatar */}
    <div className="flex flex-col items-center sm:items-start gap-2">
      <div className="w-16 h-16 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-36 xl:h-36 relative rounded-full shadow-sm border border-white/30 overflow-hidden">
        <img
        loading="lazy"
      decoding="async"
          src={data?.image ? IMAGE_URL + data?.image : "/default.jpeg"}
          alt="Profile"
          className="w-full h-full object-cover rounded-full"
        />
      </div>

      {/* Mobile Edit Button (below avatar) */}
      <button
        type="button"
        onClick={() => navigate('/edit-profile')}
        className="text-white mt-2 flex items-center gap-1 text-sm md:hidden hover:text-[#00C6FF]"
      >
        <FiEdit className="w-5 h-5" />
        <span>Edit Profile</span>
      </button>
    </div>

    {/* Info Section */}
    <div className="flex flex-col text-center sm:text-left md:gap-2 w-full">
      
      {/* Desktop Edit Button (above name, aligned left) */}
      <div className="hidden md:flex justify-start">
        <button
          type="button"
          onClick={() => navigate('/edit-profile')}
          className="text-white mb-2 flex items-center gap-1 text-sm md:text-base hover:text-[#00C6FF]"
        >
          <FiEdit className="w-5 h-5 md:w-6 md:h-6" />
          <span>Edit Profile</span>
        </button>
      </div>

      <h4 className="text-lg md:text-2xl lg:text-3xl xl:text-4xl font-bold text-white capitalize">
        {data?.name}
      </h4>
      <h4 className="text-xs md:text-sm lg:text-base text-white break-all">
        {data?.email}
      </h4>

{data.memberships && data.memberships?.length > 0 && (
  <div className="relative mt-3 p-3 bg-[#0a0a0a] rounded-lg shadow-md">
    
    {/* 🔹 Label for recent purchase */}
    <span className="absolute -top-2 left-3 bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full shadow-sm">
     Recent Purchase
    </span>

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      
      {/* Left Side */}
      <div className="flex items-start md:items-center space-x-3">
        <span className="text-2xl md:text-4xl animate-pulse">👑</span>
        <div>
          <h3 className="text-base md:text-xl font-bold text-transparent bg-clip-text bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)]
 drop-shadow-md">
            {latestCompleted?.mangoName}
          </h3>
          {latestCompleted?.recurringType === "onetime" ? (
            <p className="text-xs md:text-sm text-gray-300">
              ({latestCompleted?.recurringType})
            </p>
          ) : (
            latestCompleted?.expiryDate && (
              <p className="text-xs md:text-sm text-gray-300">
                Valid Till:{" "}
                <span className="text-white">
                  {latestCompleted?.expiryDate ?? "--"}
                </span>
              </p>
            )
          )}
        </div>
      </div>

      {/* Right Side */}
      <div className="flex items-center gap-2 md:gap-4">
        <span className="text-sm md:text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#0068FF] to-[#00C6FF] drop-shadow-md">
          ₹{latestCompleted?.amount}/{latestCompleted?.recurringType}
        </span>
        {latestCompleted?.isExpired === true && (
          <span className="bg-red-600 text-red-100 text-[10px] md:text-xs font-bold px-2 py-1 rounded-full">
            Expired
          </span>
        )}
      </div>
    </div>
  </div>
)}

    </div>
  </div>
</div>


        {/* Navigation Tabs */}
        <div
          className="flex gap-8 border-b-[1px] border-gray-500 dark:border-white/[0.1] px-5 mt-5 overflow-auto container mx-auto px-4 max-w-[80rem]"
          style={{ scrollbarWidth: "none" }}
        >
          {["Purchased Plans" , "Saved Prompts" ,"Purchased"].map((tab) => (
            <button
              key={tab}
              className={`text-sm w-max ${activeTab === tab
                ? "border-b-[2px] border-white text-primary font-bold pb-3"
                : "text-white/60"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.replace("-", " ").toUpperCase()}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="container mx-auto px-4 max-w-[80rem]">{tabContent[activeTab]}</div>
      </div>

      {/* ProfileSidebarMenu */}
      <ProfileSidebarMenu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default MyProfile;


const MySubscription = ({ data }) => {
  return <>
    <div className="grid gap-4">
      {data && data.memberships?.length > 0 && data.memberships.map((sub, idx) => (
        <>
          <div
            key={sub._id || idx}
            className="bg-[#2F2F2F] rounded-2xl shadow-md p-5 hover:shadow-lg transition duration-300 mt-5"
          >
            <div className="flex justify-between items-center mb-2">
              {/* <h3 className="text-lg font-medium text-white">{sub.mangoName}</h3>
                   */}
              <h3 className="text-lg md:text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#0068FF] to-[#00C6FF] drop-shadow-md">
                {sub?.mangoName}
              </h3>
              <div className="flex items-center gap-3">
                {/* <span className="text-white font-semibold">₹{sub.amount}/{sub.recurringType}</span> */}
                <span className="text-lg md:text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#0068FF] to-[#00C6FF] drop-shadow-md">
                  ₹{sub?.amount}/{sub?.recurringType}
                </span>
                {sub.isExpired === true && (
                  <span className="bg-red-600 text-red-100 text-xs font-bold px-2 py-1 rounded-full">
                    Expired
                  </span>
                )}
              </div>
            </div>
            <div className="text-sm text-gray-400">
              {/* <p>Duration: <span className="text-white">{sub.recurringType}</span></p> */}
              <p>Valid From: <span className="text-white">{sub.orderTime ? moment(sub?.orderTime).format('DD-MM-YYYY hh:mm A') : ''}</span></p>
              <p>Valid Till: <span className="text-white">{sub.expiryDate ? sub.expiryDate : '--'}</span></p>
            </div>
          </div>

        </>
      ))}

      {
        (data.memberships?.length === 0) && <>
          <p>No subscription available</p>
        </>
      }
    </div>
  </>
}

const MyBundles = ({ categories, isLoading, visibleCount }) => {
  const navigate = useNavigate();
  return <>
    <div className="grid gap-4">
       {isLoading ? (
        <p className="text-center text-gray-400">Loading...</p>
        ) : categories.length === 0 ? (
          <p className="text-center text-gray-400">No Purchased Prompts</p>
        ) : (
     <div className="max-w-6xl mx-auto">

  {/* ===== DESKTOP TABLE ===== */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full border border-gray-700 rounded-xl overflow-hidden table-fixed">
      <thead className="bg-[#1c1c1e]">
        <tr className="text-sm text-gray-300">
          <th className="p-4 w-[100px] text-left">Image</th>
          <th className="p-4 text-left">Category</th>
          <th className="p-4 w-[160px] text-center">Purchase Date</th>
          <th className="p-4 w-[140px] text-center">Action</th>
        </tr>
      </thead>

      <tbody>
        {categories.slice(0, visibleCount).map((cat) => (
          <tr
            key={cat._id}
            className="border-t border-gray-700 hover:bg-[#222]"
          >
            <td className="p-4">
              <img
              loading="lazy"
            decoding="async"
                src={IMAGE_URL + cat.image}
                onError={(e) =>
                  (e.target.src = "/just-launch-default.png")
                }
                className="w-16 h-16 rounded-lg object-cover"
              />
            </td>

            <td className="p-4 text-[#00AAE6] font-semibold truncate">
              {cat.category_name}
            </td>

            <td className="p-4 text-center text-white text-sm">
              {cat.purchaseDate
                ? moment(cat.purchaseDate).format("DD MMM YYYY")
                : "--"}
            </td>

            <td className="p-4 text-center">
              <button
          onClick={() =>
           navigate(`/my-prompts-bundle/category/${cat._id}`)
          }
          className="mt-3 inline-flex items-center gap-2 px-3 py-1.5
          rounded-md text-xs !text-white
          bg-gradient-to-r from-[#d54d09] via-[#e1307a] to-[#436cff]"
        >
          👁 View
        </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* ===== MOBILE CARDS ===== */}
  <div className="md:hidden space-y-4">
    {categories.slice(0, visibleCount).map((cat) => (
      <div
        key={cat._id}
        className="bg-[#1c1c1e] rounded-xl p-4 flex gap-4"
      >
        <img
        loading="lazy"
      decoding="async"
          src={IMAGE_URL + cat.image}
          onError={(e) =>
            (e.target.src = "/just-launch-default.png")
          }
          className="w-16 h-16 rounded-lg object-cover shrink-0"
        />

        <div className="flex-1">
          <p className="text-[#00AAE6] font-semibold text-sm leading-tight">
            {cat.category_name}
          </p>

          <p className="text-gray-400 text-xs mt-1">
            Purchased on{" "}
            <span className="text-white">
              {cat.purchaseDate
                ? moment(cat.purchaseDate).format("DD MMM YYYY")
                : "--"}
            </span>
          </p>

          <button
          onClick={() =>
            navigate(`/my-prompts-bundle/category/${cat._id}`)
          }
          className="mt-3 inline-flex items-center gap-2 px-3 py-1.5
          rounded-md text-xs !text-white
          bg-gradient-to-r from-[#d54d09] via-[#e1307a] to-[#436cff]"
        >
          👁 View
        </button>

        </div>
      </div>
    ))}
  </div>

</div>




        )}
    </div>
  </>
}